import React, { ReactNode } from 'react';
import { useFontSizeSettings } from '../hooks/useFontSizeSettings';
import { FontSizeContext } from './FontSizeContextValue';

export const FontSizeProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { selectedFontSize, getFontSizeMultiplier, handleFontSizeSelect } =
    useFontSizeSettings();

  const scaleFontSize = (baseFontSize: string): string => {
    const numericValue = parseFloat(baseFontSize);
    const unit = baseFontSize.replace(numericValue.toString(), '');
    return `${numericValue * getFontSizeMultiplier()}${unit}`;
  };

  return (
    <FontSizeContext.Provider
      value={{ selectedFontSize, scaleFontSize, handleFontSizeSelect }}
    >
      {children}
    </FontSizeContext.Provider>
  );
};
